import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationConfigurationService {
  applicationLanguage: { languageId: number, languageName: string }
  constructor() {
    this.applicationLanguage = { languageId: 0, languageName: "" };
  }

  setApplicationLanguage(languageId, languageName) {
    this.applicationLanguage.languageId = languageId;
    this.applicationLanguage.languageName = languageName;
  }

  getApplicationConfiguration(): { languageId: number, languageName: string }{
   return this.applicationLanguage;
  }
}
